import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddTaskComponent } from './common/add-task/add-task.component';
import { MatButtonModule, MatCheckboxModule, MatChipsModule, MatDialogRef, MatFormFieldModule, MatGridListModule, MatIconModule,
   MatInputModule, MatListModule, MatMenuModule, MatSelectModule, MatSidenavModule, MatToolbarModule, MAT_DIALOG_DATA } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DesktopAppComponent } from './common/desktop-app/desktop-app.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

import { AddLocationComponent } from './common/add-location/add-location.component';
import { AddRoleComponent } from './common/add-role/add-role.component';
import { AddOrganizationComponent } from './common/add-organization/add-organization.component';
import { TodoListItemService } from 'app/main/pages/todo-list/todo-list-item/todo-list-item.service';
import { AddTimeSheetComponent } from './common/add-time-sheet/add-time-sheet.component';
import { ToastrModule } from 'ngx-toastr';
import { AppImageDirective } from './common/app-image-directive';


@NgModule({
  declarations: [
    AddTaskComponent,
    DesktopAppComponent,
    AddLocationComponent,
    AddRoleComponent,
    AddOrganizationComponent,
    AddTimeSheetComponent,
    AppImageDirective
  ],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatGridListModule,
    MatSidenavModule,
    MatListModule,
    MatChipsModule,
    BrowserModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatMenuModule,
    MatDatepickerModule,
    FlexLayoutModule,
    MatInputModule,
    NgxMaterialTimepickerModule,
    FormsModule,
    MatCheckboxModule,
    ToastrModule
  ],
  entryComponents: [AddTimeSheetComponent],
  providers: [
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
    TodoListItemService
  ],
  exports: [AddTaskComponent, DesktopAppComponent, AddOrganizationComponent, AddTimeSheetComponent, AppImageDirective]
})
export class SharedModule { }
